export const SET_LOADING = 'SET_LOADING'
export const SET_DRIVER_ON_REQUEST = 'SET_DRIVER_ON_REQUEST'
export const UPDATE_DRIVER_ON_REQUEST = 'UPDATE_DRIVER_ON_REQUEST'
export const CREATE_DRIVER_ON_REQUEST = 'CREATE_DRIVER_ON_REQUEST'
export const CREATE_AUTO_ON_REQUEST = 'CREATE_AUTO_ON_REQUEST'

export const SET_CARS_ON_REQUEST = 'SET_CARS_ON_REQUEST'
export const UPDATE_AUTOMOBILE_ON_REQUEST = 'UPDATE_AUTOMOBILE_ON_REQUEST'
